import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LoginPage from './pages/auth/LoginPage';
import UnverifiedPage from './pages/auth/UnverifiedPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import HomePage from './pages/config/HomePage';
import AddConfigPage from './pages/config/AddConfigPage';
import EditConfigPage from './pages/config/EditConfigPage';
import { NotificationProvider } from './context/NotificationContext';
import './App.css';

function App() {
  const { isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <NotificationProvider>
      <Router>
        <Routes>
          {/* Root route - redirect to login or dashboard based on auth status */}
          <Route path="/" element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
          } />
          
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unverified" element={<UnverifiedPage />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/add" element={
            <ProtectedRoute>
              <AddConfigPage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/edit/:configId" element={
            <ProtectedRoute>
              <EditConfigPage />
            </ProtectedRoute>
          } />
          
          {/* Legacy routes for backward compatibility */}
          <Route path="/add" element={
            <ProtectedRoute>
              <AddConfigPage />
            </ProtectedRoute>
          } />
          <Route path="/edit/:configId" element={
            <ProtectedRoute>
              <EditConfigPage />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </NotificationProvider>
  );
}

export default App; 